import { Trans } from '@lingui/macro'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import { Redirect } from 'react-router-dom'
import { EgretLoadable } from '../../../egret'
import { authRoles } from '../../auth/authRoles'
import Committees from './committees/Committees'
import EditCommittee from './committees/EditCommittee'
import ExecutiveSummaries from './committees/ExecutiveSummaries'

export const GRANTS_PATH = {
  MANAGE_MEMBERS: '/organization/manage',
  JOIN_ORGANIZATION: '/grants/join-organization'
}

const OrganisationDetails = EgretLoadable({
  loader: () => import('./organization/OrganisationDetails')
})

const JoinOrganization = EgretLoadable({
  loader: () => import('../join-organization-flow/JoinOrganization')
})

const ReviewApplications = EgretLoadable({
  loader: () => import('./committees/ReviewApplications')
})

const Homepage = EgretLoadable({
  loader: () => import('./grantsHome/GrantsHome')
})

const Meetings = EgretLoadable({
  loader: () => import('./committees/Meetings')
})

const AllocationCommitteeMeetingDetails = EgretLoadable({
  loader: () => import('./committees/AllocationCommitteeMeetingDetails'),
})

const CommitteeApplicationsList = EgretLoadable({
  loader: () => import('./committees/CommitteeApplicationsList')
})

const ServiceInventory = EgretLoadable({
  loader: () => import('./ServiceInventory')
})

const EditService = EgretLoadable({
  loader: () => import('./EditService')
})

const ApplicationEdit = EgretLoadable({
  loader: () => import('./applications/old-application/ApplicationEdit')
})

const ActionPlan = EgretLoadable({
  loader: () => import('./action-plan/ActionPlan')
})

const Reports = EgretLoadable({
  loader: () => import('./grantee-reports/Reports')
})

const ExternalReviewSurvey = EgretLoadable({
  loader: () => import('./external-reviewer/ExternalReviewSurvey')
})

const AcceptReviewRequest = EgretLoadable({
  loader: () => import('./external-reviewer/ReviewerAccept')
})

const GranteeReport = EgretLoadable({
  loader: () => import('./grantee-reports/GranteeReport')
})

const GranteeReportPreview = EgretLoadable({
  loader: () => import('./grantee-reports/GranteeReportPreview')
})

const Calendar = EgretLoadable({
  loader: () => import('./calendar/UserCalendar')
})

const AboutMe = EgretLoadable({
  loader: () => import('./external-reviewer/AboutMe')
})

const ApplyToExternalReview = EgretLoadable({
  loader: () => import('./external-reviewer/ApplyToExternalReview')
})

const AssignedOpportunities = EgretLoadable({
  loader: () => import('./external-reviewer/AssignedOpportunities')
})

const ApplicantInformation = EgretLoadable({
  loader: () => import('./ApplicantInformation')
})

const ActionTemplates = EgretLoadable({
  loader: () => import('./ActionTemplates')
})

const ActionTemplate = EgretLoadable({
  loader: () => import('./ActionTemplate')
})

const PrintView = EgretLoadable({
  loader: () => import('./applications/old-application/PrintView')
})

const Organizations = EgretLoadable({
  loader: () => import('./organization/UserOrganizations')
})

const ManageOrganizationMembers = EgretLoadable({
  loader: () => import('./organization/ManageOrganizationMembers')
})

const TechnicalAdvisories = EgretLoadable({
  loader: () => import('../grants/TechnicalAdvisories')
})

const grantsRoutes = [
  {
    path: '/grants/organization-details/:id?',
    component: OrganisationDetails,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: '/grants/Committees/:initialTab?',
    component: Committees
  },
  {
    path: '/grants/Workgroups/:initialTab?',
    component: Committees,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_WORKGROUPS_LABEL</Trans>
  },
  {
    path: '/grants/EditCommittee/:id',
    component: EditCommittee
  },
  {
    path: '/grants/EditWorkgroup/:id',
    component: EditCommittee,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_EDIT_WORKGROUP_LABEL</Trans>,
  },
  {
    path: '/grants/grant-application/:id/:viewType?',
    component: EgretLoadable({
      loader: () => import('./applications/Application')
    }),
    auth: authRoles.grantee,
    label: <Trans>GRANTS_ROUTES_GRANT_APPLICATION_ROUTE_LABEL</Trans>,
    isConditionable: true,
    id: 'grant-application',
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: '/grants/prequalification/:id/:viewType?',
    component: EgretLoadable({
      loader: () => import('./applications/Prequalification')
    }),
    auth: authRoles.grantee,
    label: <Trans>GRANTS_ROUTES_GRANTS_PREQUALIFICATION_ROUTE_LABEL</Trans>,
    isConditionable: true,
    id: 'prequalification'
  },
  {
    path: '/grants/TechnicalAdvisories',
    component: TechnicalAdvisories,
    auth: authRoles.grantee
  },
  {
    path: '/grants/ActionTemplates',
    component: ActionTemplates,
    auth: authRoles.editor,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_ACTION_TEMPLATES_LABEL</Trans>
  },
  {
    path: '/grants/ActionTemplate/:id',
    component: ActionTemplate,
    auth: authRoles.editor,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_ACTION_TEMPLATE_EDITOR_LABEL</Trans>
  },
  {
    path: '/grants/home',
    component: Homepage,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_HOMEPAGE_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/grants/executive-summaries/:committee',
    component: ExecutiveSummaries,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_SC_EXECUTIVE_SUMMARIES_LABEL</Trans>,
    showCollapseBtn: true,
  },
  {
    path: '/grants/Meetings/:committee',
    component: Meetings,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_MEETINGS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/grants/AllocationCommitteeMeetingDetails/:id',
    component: AllocationCommitteeMeetingDetails,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_AC_MEETINGS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/grants/committee/ac',
    component: CommitteeApplicationsList,
    auth: authRoles.allocationCommittee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_EXECUTIVE_SUMMARIES</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/grants/committee/board',
    component: CommitteeApplicationsList,
    auth: authRoles.board,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_BOARD_EXECUTIVE_SUMMARIES_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/grants/committee/cmhc',
    component: CommitteeApplicationsList,
    auth: authRoles.cmhc,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_CMHC_EXECUTIVE_SUMMARIES_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/grants/ServiceInventory',
    component: ServiceInventory,
    auth: authRoles.admin
  },
  {
    path: '/grants/EditService/:id',
    component: EditService,
    auth: authRoles.admin
  },
  {
    path: '/grants/review-application/:committee/:id',
    component: ReviewApplications,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_REVIEW_APPLICATION_LABEL</Trans>,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: '/grants/Application/:id',
    component: ApplicationEdit,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_OLD_APPLICATION_FORM_LABEL</Trans>
  },
  {
    path: '/calendar',
    component: Calendar,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_CALENDAR_LABEL</Trans>
  },
  {
    path: '/grants/ActionPlan',
    component: ActionPlan,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_ACTION_PLAN_LABEL</Trans>,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: '/grants/Reports',
    component: Reports,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_GRANTEE_REPORTS</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/grants/reviewer-profile',
    component: AboutMe,
    label: <Trans>NAVIGATIONS_REVIEWER_PROFILE</Trans>,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: '/grants/apply-to-external-reviewer',
    component: ApplyToExternalReview,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_BECOME_EXTERNAL_REVIEWER</Trans>
  },
  {
    path: '/grants/assigned-reviews',
    component: AssignedOpportunities,
    auth: authRoles.reviewer,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_ASSIGNED_REVIEWS</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/grants/ExternalReviewSurvey/:id/:mode',
    component: ExternalReviewSurvey,
    auth: authRoles.reviewer,
    isTranslatable: true,
    isConditionable: true,
    id: 'ExternalReviewSurvey',
    label: <Trans>GRANTS_ROUTES_EXTERNAL_REVIEW_LABEL</Trans>,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: '/grants/AcceptReview/:id',
    component: AcceptReviewRequest,
    auth: authRoles.reviewer,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_ACCEPT_EXTERNAL_REVIEW_LABEL</Trans>
  },
  {
    path: '/grants/report/:id/',
    component: GranteeReport,
    auth: authRoles.grantee,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: '/grants/report-preview/:id/',
    component: GranteeReportPreview,
    auth: authRoles.grantee
  },
  {
    path: '/grants/print/:id',
    component: PrintView
  },
  {
    path: '/grants/Organizations',
    component: Organizations,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_MANAGE_ORGANIZATIONS_LABEL</Trans>
  },
  {
    path: `${GRANTS_PATH.MANAGE_MEMBERS}/:id?`,
    component: ManageOrganizationMembers,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_MANAGE_USERS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/grants/user-profile',
    component: sfOauthConfig.isInternal
      ? () => <Redirect to='/session/404' />
      : ApplicantInformation,
    auth: authRoles.user,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: GRANTS_PATH.JOIN_ORGANIZATION,
    component: JoinOrganization,
    auth: authRoles.grantee,
    isTranslatable: true,
    label: <Trans>GRANTS_ROUTES_JOIN_ORGANIZATION_LABEL</Trans>
  }
]

export default grantsRoutes
